import { CLOSE_CREATE_EXCLUSIONS_INFO_MODAL, OPEN_CREATE_EXCLUSIONS_INFO_MODAL, OPEN_UPDATE_EXCLUSIONS_INFO_MODAL } from "../actions/actionTypes";

const initialState = {
    allExclusionsInfo: [],
    error: null,
    isCreateExclusionsInfoModalOpen: false,
    selectedExclusionsInfoId: null,
  };
  
  const exclusionsInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ALL_EXCLUSIONS_INFOS_SUCCESS':
            return { ...state, allExclusionsInfo: action.payload, error: null };
        case 'CREATE_EXCLUSIONS_INFO_SUCCESS':
        case 'UPDATE_EXCLUSIONS_INFO_SUCCESS':
            return {
                ...state,
                allExclusionsInfo: [ ...state.allExclusionsInfo, ...action.payload ],
                error: null,
            };
        case OPEN_CREATE_EXCLUSIONS_INFO_MODAL:
            return {...state, isCreateExclusionsInfoModalOpen: true}
        case OPEN_UPDATE_EXCLUSIONS_INFO_MODAL:
            return {...state, isCreateExclusionsInfoModalOpen: true, selectedExclusionsInfoId: action.payload}
        case CLOSE_CREATE_EXCLUSIONS_INFO_MODAL:
            return {...state, isCreateExclusionsInfoModalOpen: false, selectedExclusionsInfoId: null}
        case 'ALL_EXCLUSIONS_INFOS_FAILURE':
        case 'CREATE_EXCLUSIONS_INFO_FAILURE':
        case 'UPDATE_EXCLUSIONS_INFO_FAILURE':
            return { ...state, error: action.payload };
        default:
            return state;
    }
  };
  
  export default exclusionsInfoReducer;